'use strict';

var ValidationSummaryDirective = function ValidationSummaryDirective() {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      msg: '=',
      hideAction: '&'
    },
    controller: 'ValidationSummaryController',
    template: require('../templates/validation-summary.html')
  };
};
ValidationSummaryDirective.$inject = [];
module.exports = ValidationSummaryDirective;